import { render, staticRenderFns } from "./PlatformForCustomer.vue?vue&type=template&id=3a4a6a8c&scoped=true&"
import script from "./PlatformForCustomer.vue?vue&type=script&lang=js&"
export * from "./PlatformForCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PlatformForCustomer.vue?vue&type=style&index=0&id=3a4a6a8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4a6a8c",
  null
  
)

export default component.exports